/* eslint-disable object-property-newline */
import { nanoid } from 'nanoid';
import storage from './storage';

export function isInteger(n) {
  return typeof n === 'number' && Math.floor(n) === n;
}

export function getDeviceId() {
  try {
    let deviceId = storage.getItem('deviceId');

    if (!deviceId) {
      deviceId = nanoid();
      storage.setItem('deviceId', deviceId);
    }

    return deviceId;
  } catch (err) {
    return nanoid();
  }
}

const CANCELED_STATE = Symbol('canceled');
export function createCancellablePromise(resolver) {
  let cancel = null;
  const promise = new Promise((resolve, reject) => {
    cancel = () => resolve(CANCELED_STATE);
    resolver(resolve, reject);
  });
  promise.cancel = cancel;
  promise.CANCELED_STATE = CANCELED_STATE;

  return promise;
}

export function getChannelPlayable(viewable) {
  // Channel
  if (viewable?.__typename === 'Channel') {
    return viewable?.playable;
  }
  // Show/Program/Movie with broadcast playable
  if (viewable?.defaultPlayable?.channel?.playable) {
    return viewable.defaultPlayable.channel.playable;
  }

  return {};
}
